import { ChangeDetectorRef, Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SseService } from '../../services/SseService';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { OptimalWallet } from 'src/app/interface/OptimalWallet';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';
import { DiversificadorService } from 'src/app/services/diversificador.services';
import { TemaService } from 'src/app/services/tema.services';
import { DialogNameComponent } from '../dialog-name/dialog-name.component';
import { Subscription, catchError, firstValueFrom, forkJoin, of, tap } from 'rxjs';
// replaced MatSnackBar snackbar notifications with ToastrService
import { Notificacion } from 'src/app/models/notificacion';
import { NotificacionService } from 'src/app/services/notificacion.service';
import { ToastrService } from "ngx-toastr";
import { HelpDialogComponent, HelpDialogData } from '../common/help-dialog/help-dialog.component';
import { CarteraOptimaParamsService } from 'src/app/services/cartera-optima-params.service';
import { GraficaModeloComponent, ModeloGraficaOpcion } from '../graficas/grafica-modelo/grafica-modelo.component';
import { MAX_NOMBRE_CARTERA, nombreCarteraConSufijo } from '../../utils/nombre-cartera.util';

@Component({
  selector: 'app-diversificador',
  templateUrl: './diversificador.component.html',
  styleUrl: './diversificador.component.scss'
})
export class DiversificadorComponent implements OnInit, OnDestroy {
  @ViewChild(GraficaModeloComponent) graficaAnalisis: GraficaModeloComponent;
  public metaapi: boolean = false;
  public selectedTab: number = 0;
  public modelo: boolean = false;
  public isPlanificador: boolean = true;
  public loading: boolean = false;
  public isDark: boolean = false;
  private SubTema: Subscription;
  private subOptimaWallet: Subscription;
  public isAutomatico: boolean = false;
  public isAnalisis: boolean;
  public subIsanalisis: Subscription;
  public carteraActual: number[] = Array(100).fill(0);
  get sinCarteraSeleccionada(): boolean { return this.carteraActual.every(id => id === 0); }
  public idcarterasOptima: number[] = Array(100).fill(0);
  public tiporiesgo: string = '';
  public valoriresgo: number = 0;
  public arraytiporiesgo: string[] = [];
  public arrayvalorriesgo: number[] = [];
  existemargen: boolean = true;
  existeriesgo: boolean = true;
  selectedTab2: number;
  efectivopositivo: boolean = true;
  public texto: string = ">>"
  public mouseSobreDiv: boolean = false;
  private panelTimeout: any;
  public listaMercado: boolean = localStorage.getItem('diversificador_panel_listaMercado') !== 'false';
  public cartera: boolean = localStorage.getItem('diversificador_panel_cartera') !== 'false';
  public defaultOptima : OptimalWallet={
    apalancamiento: 1,
    bajista: false,
    capitalinicial: 100000.0,
    idcartera: 0,
    nombre: '',
    valorLiquidativo: 100000,
    valorliquidativoTemp: 0.0,
    riesgomaximo: 50.0,
    tipocuenta: 'MARGEN',
    tiporiesgo: 'LIMITADO',
    riesgo: 1000.0,
    comisionbroker: 10.0,
    idmercado: 0,
    intervalotiempo: 2,
    prima: false,
    participacion: false,
    simulado: true,
    poderCompra:200000,
    numeroReconfiguracion: 0,
    stopLoss: 20,
    profit: 10,
    capitales: [1000.0, 1000.0],
    fondosDisponibles: 100000,
    margen: 0,
    margenRequeridoPor: 30,
    controlMarginCall: 75.0,
    lista: 0,
    nOperaciones: 0,
    maxDiferenciaCierres: 0.0,
    rendimientoNeto: 0.0,
    rendimientomedioanual: 0.0,
    rendimientoacumuladoanual: 0.0,
    tasacrecimientoanualcompuesto: 0.0,
    periodosoperativa: 0,
    beneficioneto: 0.0,
    beneficionetoporcentual: 0.0,
    mayorretrocesodesdemaximo: 0.0,
    mayorretrocesodesdemaximoporcentual: 0.0,
    mediabeneficioperdidaporcentual: 0.0,
    sumaresiduosbeneficioperdidaporcentual: 0.0,
    volatilidadperiodo: 0.0,
    volatilidadanual: 0.0,
    mesesdd: 0,
    maximoretrocesoperiodo: 0.0,
    sumarrendimientosanuales: 0.0,
    prombeneficiointervalo: 0.0,
    prombeneficionintervaloporcentual: 0.0,
    sumatorio: false,
    coeficientevolatilidadanual: 1.0,
    ratiobeneficioriesgo: 0.0,
    modelodesde: '',
    efectivo: 100000.0,
    gastosGestionPor: 1.0,
    gastosPrestamoPor: 8.0,
    nRecalcular: 0,
    idModelo: 0,
    liquidativos: null,
    sincro: true,auto:false,
    idCarteras: Array(100).fill(0),
    subCarteras:'',
    chkgastogest:true,
    chkgastoprest:true,
    chkcomisionbroker:true
};

  divOptimalWallet: OptimalWallet;
  public fecharegistrosuscripcionurl: string = '';
  private fechaSuscripcionOriginal: string = '';
  private originalSuscripcionIdCarteras: number[] = [];
  public idcarterasOptimaActual: number[] = Array(100).fill(0);
  /** Modelos de las carteras seleccionadas, para el combo "Modelo" de la gráfica embebida. */
  public modelosGrafica: ModeloGraficaOpcion[] = [];
  private parametrosCache = new Map<number, any>();
  private seqParametros = 0;
  nombreSugerido: String = '';
  purchaseTypes: string[] = [
    'LIMITADO',
    'FIJO', 'MIXTO'
  ];

  accountType: string[] = [
    'MARGEN',
    'NOMINAL'
  ]
  disabledByAccount: boolean;
  theme: string;

  constructor(        private toastr: ToastrService,

    private apisseservice: SseService,
    private _router: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private cookieService: CookieService,
    private diversificadorsv: DiversificadorService,
    public temaservicio: TemaService,
    private cdr: ChangeDetectorRef,
    private notificacionService: NotificacionService,
    private carteraOptimaParamsService: CarteraOptimaParamsService
  ) {


  }
  expandirDiv() {
    if (this.panelTimeout) { clearTimeout(this.panelTimeout); this.panelTimeout = null; }
    this.texto = "<<";
    this.mouseSobreDiv = true;
  }

  contraerDiv() {
    this.panelTimeout = setTimeout(() => {
      this.texto = ">>";
      this.mouseSobreDiv = false;
    }, 200);
  }

  ngOnDestroy() {
    this.SubTema.unsubscribe();
    this.subOptimaWallet.unsubscribe();
  }
  ngOnInit() {
    this.subOptimaWallet = this.diversificadorsv.valDivOptimaWallet$.subscribe({
      next: (data: any) => {
        this.divOptimalWallet = data;
      }
    });
    this._router.queryParams.subscribe(params => {
      let data = params['data'];
      let fecharegistrosuscripcion = params['fecharegistrosuscripcion'];
      // Solo se usa para el "latch" único del valor original; el valor de trabajo
      // (fecharegistrosuscripcionurl) lo gobierna en exclusiva recalcularPonderador().
      if (fecharegistrosuscripcion && !this.fechaSuscripcionOriginal) {
        this.fechaSuscripcionOriginal = fecharegistrosuscripcion;
        this.fecharegistrosuscripcionurl = fecharegistrosuscripcion;
        if (params['idcartera']) {
          this.originalSuscripcionIdCarteras = params['idcartera'].split(',')
            .map((id: string) => +id)
            .filter((id: number) => id !== 0);
        }
      }
      if (data === 'Diversificador') {
        this.modelo = false;
        this.isPlanificador = true;
      } else if (data === 'Planificador') {
        this.modelo = true;
        this.isPlanificador = false;
      }
      
      // Los parámetros (parametros/{idcarteraoptima}) ya no se cargan aquí: los carga
      // recalcularPonderador() — el mismo evento que disparan los checks de lista-modelo, que
      // también preselecciona las carteras de la URL — para que el reset a defaultOptima no los pise.
      if (params['idcarteraoptima']) {
        const idcarterasOptima = params['idcarteraoptima'].split(',').map((id: string) => +id);
        this.diversificadorsv.updateDivIdCarterasOptima(idcarterasOptima);
      }
      
      // Cargar idcartera si existe en los parámetros
      if (params['idcartera']) {
        console.log('📋 ID Cartera recibido:', params['idcartera']);
        const parsedIds: number[] = params['idcartera'].split(',').map((id: string) => +id);
        while (parsedIds.length < 100) parsedIds.push(0);
        const idCarterasArray = parsedIds.slice(0, 100);
        this.carteraActual = idCarterasArray;
        this.diversificadorsv.updateDivIdCarteras(idCarterasArray);
        if (this.divOptimalWallet) {
          this.divOptimalWallet.idCarteras = idCarterasArray;
        }
      }
    });
    this.SubTema = this.temaservicio.valDarkTheme.subscribe({
      next: (data: any) => {
        this.isDark = data;
        this.theme = data ? 'dark-theme' : 'light-theme';
      }
    });
    this.subIsanalisis = this.diversificadorsv.valDivisAnalisis$.subscribe({
      next: (data: any)=>{
        this.isAnalisis =data;
      }
    })
    // Restaurar anchos persistidos
    setTimeout(() => this.restoreSavedWidths(), 50);
  }
  nombresugerir(array: any){
    console.log('data', array);
    this.nombreSugerido = '';
    for (let i = 0; i < array.length; i++) {
      this.nombreSugerido += array[i];
    }
  }
  showTab(tab: any) {
    if (tab == 'cartera') {
      console.log(tab);
      this.cartera = !this.cartera;
      localStorage.setItem('diversificador_panel_cartera', String(this.cartera));
    } else {
      this.listaMercado = !this.listaMercado;
      localStorage.setItem('diversificador_panel_listaMercado', String(this.listaMercado));
    }
  }
  getOptimalWallet(data: any, endpoint: string, diversificador: boolean) {
    this.existemargen = true;
    this.existeriesgo = true;
    this.efectivopositivo = true;
    let liqval: any[] = [];
    let ventOp: any[] = [];
    let vla: any[] = [];
    let rentabilida: any[] = [];
    let riesgo: any[] = [];
    let rendimiendoAnual: any[] = [];
    let pos: any[] = [];
    let ope: any[] = [];
    this.loading = true;
    //agregar a data   data.metaapi = this.metaapi;
    data.metaapi = this.metaapi;
    // Se arma un payload aparte (no se muta data/this.divOptimalWallet) para no perder el array de
    // 100 slots que usa el resto del componente (sinCarteraSeleccionada, todosCeros, etc.). Solo se
    // mandan las carteras con idcartera != 0 -- si no queda ninguna se manda '0' en vez de '' porque
    // el backend arma "IN (" + idCarteras.replace(",0","") + ")" y con '' queda "IN ()" (SQL invalida).
    const idCarterasFull: number[] = data.idCarteras || [];
    const seleccion = idCarterasFull
      .map((id, i) => ({ id, tiporiesgo: this.arraytiporiesgo[i], riesgo: this.arrayvalorriesgo[i] }))
      .filter(x => x.id !== 0);
    const payload = {
      ...data,
      idCarteras: seleccion.length > 0 ? seleccion.map(x => x.id).join(',') : '0',
      tiposriesgo: seleccion.map(x => x.tiporiesgo).join(','),
      valoresriesgo: seleccion.map(x => x.riesgo).join(',')
    };
    payload.fecharegistrosuscripcion = this.fecharegistrosuscripcionurl;
    this.apisseservice.apiGetSse(endpoint, true, payload).subscribe({
      next: (resp: any) => {
        if (resp.name === 'ope') {
          ope.push(resp.data);
          if (diversificador) {
            //     console.log("Operaciones Divsersificador",ope);
            this.diversificadorsv.updateDivOpe(ope);
          }
          var temp = resp.data[resp.data.length - 1];
          this.divOptimalWallet.margen = parseFloat(parseFloat(temp.margentotal).toFixed(2));
          this.divOptimalWallet.fondosDisponibles = parseFloat(parseFloat(temp.fondosdisponibles).toFixed(2));
          this.divOptimalWallet.poderCompra = parseFloat(parseFloat(temp.podercompra).toFixed(2));
          this.divOptimalWallet.efectivo = parseFloat(parseFloat(temp.efectivo).toFixed(2));
          this.divOptimalWallet.valorLiquidativo = parseFloat(parseFloat(temp.valorliquidativo).toFixed(2));
          this.efectivopositivo = this.divOptimalWallet.efectivo > 0;

        } else if (resp.name === 'vla') {
          vla.push(resp.data);
          if (diversificador) {
            //    console.log("Valores Latentes Divsersificador",vla);
            this.diversificadorsv.updateDivLate(vla);
          }
        } else if (resp.name === 'vli') {
          liqval.push(resp.data);
          if (diversificador) {
            //   console.log("Valores Liq Divsersificador",liqval);
            this.diversificadorsv.updateDivLiq(liqval);
          }
        } else if (resp.name === 'pos') {
          pos.push(resp.data);
          if (diversificador) {
            //     console.log("POS Divsersificador",pos);
            this.diversificadorsv.updateDivPos(pos);
          }
        }
        else if (resp.name === 'ven') {
          ventOp.push(resp.data);
          if (diversificador) {
            //   console.log("VENT Divsersificador",ventOp);
            this.diversificadorsv.updateDivVentas(ventOp);
          }
        } else if (resp.name === 'ren') {
          rentabilida.push(resp.data);
          if (diversificador) {
            //    console.log("Rentabilidad Divsersificador",rentabilida);
            this.diversificadorsv.updateDivRent(rentabilida);
          }
        } else if (resp.name === 'rie') {
          riesgo.push(resp.data);
          if (diversificador) {
            //  console.log("rie Divsersificador",resp.data);
            this.diversificadorsv.updateDivRiesgo(riesgo)
          }
        } else if (resp.name === 'rea') {
          rendimiendoAnual.push(resp.data);
          if (diversificador) {
            // console.log("rea Divsersificador",resp.data);
            this.diversificadorsv.updateDivRendAnual(rendimiendoAnual);
          }
        }else if(resp.name === 'err'){
          let errorstring = resp.data;
          let titulo = '';
          if (errorstring.includes('han superado los Requerimientos de Margen')) {
            this.existemargen = false;
            titulo = 'Control Margin Call %';
          }
          if (errorstring.includes('Se ha superado los Requerimientos de Margen para su carter')) {
          this.existemargen = false;
          titulo = 'Control Margin Call %';
          }
          if (errorstring.includes('e ha superado el riesgo máximo establecido')) {
            this.existeriesgo = false;
            titulo = 'Riesgo Maximo';
          }
          if(errorstring.includes('e ha superado el riesgo para una nueva operacion')){
            this.existeriesgo = false;
            titulo = 'Riesgo para Nueva Operacion';
          }
          titulo = titulo || 'Margen Superado';
          console.log("",resp.name);
          console.log(resp.data);
            // Show toast instead of snackbar
            this.toastr.error(resp.data, titulo, { timeOut: 30000, positionClass: 'toast-top-center' });
            this.guardarNotificacion(new Notificacion(titulo, errorstring, 'DIVERSIFICADOR'));
          }
      }, error(err) {
        console.log("hubo un error")
      }, complete: () => {
        console.log("se COMPLETO el envio de datos.");
        this.loading = false;
        console.log("this loading deberia cerrar spinner", this.loading);
        this.diversificadorsv.updateDivOptimaWallet(this.divOptimalWallet);
        this.diversificadorsv.updateDivExecuteGrap(true);
        //this.isAnalisis = false;
        this.diversificadorsv.updatedisAnalisis(true);
        this.cdr.detectChanges();

      }
    });
  }
  disabledMargin(event: any) {
    console.log(event.target.value);
    if (this.divOptimalWallet.tipocuenta == 'MARGEN') {
      this.divOptimalWallet.poderCompra = 100000
      this.disabledByAccount = false;
    }
    else {
      this.divOptimalWallet.poderCompra = 200000
      this.disabledByAccount = true;
    }
  }

   walletAnalysis() {
    this.diversificadorsv.updateDivOpe([]);
    this.diversificadorsv.updateDivLate([]);
    this.diversificadorsv.updateDivLiq([]);
    this.diversificadorsv.updateDivPos([]);
    this.diversificadorsv.updateDivVentas([]);
    this.diversificadorsv.updateDivRent([]);
    this.diversificadorsv.updateDivRiesgo([]);
    this.diversificadorsv.updateDivRendAnual([]);
    this.diversificadorsv.updatedivIsShow(false);
    console.log(this.divOptimalWallet);
    //this.divOptimalWallet.idModelo = this.modeloMercado.idModelo; 
    this.getOptimalWallet(this.divOptimalWallet, 'Recalcular?', true);
  }

  onMetaapiConflict(): void {
    this.toastr.error(
      'No se pueden combinar modelos MetaAPI con modelos estándar en la misma cartera.',
      'Tipo incompatible',
      { timeOut: 4000 }
    );
  }

  onSelectionMetaapi(value: boolean | null): void {
    this.metaapi = value ?? false;
  }

  get fechaHoraSuscripcionFormateada(): string {
    if (!this.fecharegistrosuscripcionurl) return '';
    const [fecha, horaConMs] = this.fecharegistrosuscripcionurl.split(' ');
    if (!fecha) return '';
    const [y, m, d] = fecha.split('-');
    const hora = horaConMs ? horaConMs.split('.')[0].slice(0, 5) : '';
    return hora ? `${d}/${m}/${y} ${hora}` : `${d}/${m}/${y}`;
  }

  private calcularFechaSuscripcionActiva(idCarterasSeleccionadas: number[]): string {
    if (!this.fechaSuscripcionOriginal) return '';
    const seleccionActual = idCarterasSeleccionadas.filter((id: number) => id !== 0);
    const esCompatible = seleccionActual.length === 0 ||
      seleccionActual.every((id: number) => this.originalSuscripcionIdCarteras.includes(id));
    return esCompatible ? this.fechaSuscripcionOriginal : '';
  }

  /**
   * Carga parametros/{idcarteraoptima} de la selección actual y los fusiona, en orden de slot, sobre
   * divOptimalWallet (recién reseteado a defaultOptima). Devuelve false si mientras esperaba llegó
   * otra selección (check posterior), en cuyo caso no aplica nada.
   */
  private async cargarParametrosSeleccion(idsOptima: number[]): Promise<boolean> {
    const seq = ++this.seqParametros;
    this.tiporiesgo = '';
    this.valoriresgo = 0;
    this.arraytiporiesgo = [];
    this.arrayvalorriesgo = [];

    const peticiones = idsOptima.map(id => {
      if (!(id > 0)) return of(null);
      if (this.parametrosCache.has(id)) return of(this.parametrosCache.get(id));
      return this.apisseservice.apiGetNew('parametros/' + id).pipe(
        tap((data: any) => { if (data) this.parametrosCache.set(id, data); }),
        catchError(error => {
          console.error('❌ Error cargando configuración de cartera:', id, error);
          this.toastr.error(`No se pudo cargar la configuración de la cartera ${id}`, 'Error');
          return of(null);
        })
      );
    });
    const resultados: any[] = peticiones.length > 0 ? await firstValueFrom(forkJoin(peticiones)) : [];
    if (seq !== this.seqParametros) return false;

    const riesgoAcumulado = { tiporiesgo: '', valoriresgo: 0 };
    const cargados: number[] = [];
    resultados.forEach((carteraData, i) => {
      if (!carteraData) {
        // Sin parámetros para este slot: mismo valor por defecto que defaultOptima, para no
        // desalinear arraytiporiesgo/arrayvalorriesgo respecto a idCarteras.
        this.arraytiporiesgo[i] = this.defaultOptima.tiporiesgo;
        this.arrayvalorriesgo[i] = this.defaultOptima.riesgo;
        return;
      }
      this.carteraOptimaParamsService.fusionarUnaCarteraOptima(this.divOptimalWallet, carteraData, riesgoAcumulado);
      this.arraytiporiesgo[i] = carteraData.tiporiesgo ?? this.defaultOptima.tiporiesgo;
      this.arrayvalorriesgo[i] = carteraData.riesgo ?? this.defaultOptima.riesgo;
      cargados.push(idsOptima[i]);
    });
    this.tiporiesgo = riesgoAcumulado.tiporiesgo;
    this.valoriresgo = riesgoAcumulado.valoriresgo;

    if (cargados.length > 0) {
      this.diversificadorsv.updateDivOptimaWallet(this.divOptimalWallet);
      this.cdr.detectChanges();
      const label = cargados.length === 1
        ? `Configuración de cartera ${cargados[0]} cargada`
        : `Configuración de ${cargados.length} carteras cargadas: ${cargados.join(', ')}`;
      this.toastr.success(label, 'Carteras Cargadas');
    }
    return true;
  }

  async recalcularPonderador(array: any) {
    this.carteraActual = array;
    // Único punto que actualiza la URL para esta selección — evita que dos navigate()
    // (uno del hijo lista-modelo, otro de este componente) se cancelen entre sí.
    this.fecharegistrosuscripcionurl = this.calcularFechaSuscripcionActiva(array);
    // Igual que en getOptimalWallet: solo se navega con las carteras != 0. '0' si no queda ninguna
    // seleccionada -- idcartera='' es falsy, asi que "if (params['idcartera'])" (mas abajo, al leer
    // la URL) se saltaria entero y carteraActual/arraytiporiesgo quedarian con datos obsoletos.
    const seleccionNav = array
      .map((id: number, i: number) => ({ id, idOptima: this.idcarterasOptimaActual[i] }))
      .filter((x: any) => x.id !== 0);
    this.router.navigate(['/portfolio-labs'], {
      queryParams: {
        idcarteraoptima: seleccionNav.length > 0 ? seleccionNav.map((x: any) => x.idOptima).join(',') : '0',
        idcartera: seleccionNav.length > 0 ? seleccionNav.map((x: any) => x.id).join(',') : '0',
        fecharegistrosuscripcion: this.fecharegistrosuscripcionurl || null
      },
      queryParamsHandling: 'merge'
    });
    await this.inicializarDataDiversificador();
    const vigente = await this.cargarParametrosSeleccion(seleccionNav.map((x: any) => x.idOptima));
    if (!vigente) return; // llegó otra selección mientras se cargaban los parámetros
    this.diversificadorsv.updatedivIsShow(false);
    this.divOptimalWallet.idCarteras = array;
    this.divOptimalWallet.idModelo = 0;
    //this.optimalWallet.stopLoss= 20;
    this.divOptimalWallet.bajista = false;
    console.log("ESTOS ES LA CARTERA ",this.divOptimalWallet);
    console.log("ESTOS ES LA CARTERA idCarteras ",this.divOptimalWallet.idCarteras);
    if(this.isAutomatico){
      this.getOptimalWallet(this.divOptimalWallet, 'Recalcular?', true);
    }else{ 
      this.listarOperaciones(array);
    }
    let todosCeros: boolean = this.divOptimalWallet.idCarteras.every(numero => numero === 0);
    if (todosCeros) {
      this.inicializarDataDiversificador();
    }

  }

  listarOperaciones(array: any){
    this.loading = true;
    let licencia = this.cookieService.get('auth_token');
    //{"idcartera": 340, "idModelo":0, "idcarteras": "0,0,0,0,0"}
    // Solo se manda lo seleccionado (idcartera != 0); '0' si no queda nada seleccionado, mismo
    // motivo que en getOptimalWallet (obteneroperacionesrecalculaPonderador hace IN(idCarteras.replace(",0",""))).
    const seleccionados = array.filter((id: number) => id !== 0);
    let arrayString = seleccionados.length > 0 ? seleccionados.join(',') : '0';

    if (this.fecharegistrosuscripcionurl) {
      // Recalcula/regenera las operaciones desde la fecha de suscripción (no lee tbl_operacion histórico)
      let dataJason = {
        idcarteras: arrayString,
        fecharegistrosuscripcion: this.fecharegistrosuscripcionurl,
        tipoBroker: this.metaapi ? 'METAAPI' : 'IBKR',
      }
      this.apisseservice.apiPostNew('broker/revisarModeloBrokerIajavaDesde', dataJason, licencia).subscribe({
        next: (data: any)=>{
            this.diversificadorsv.updateDivOpe(data.operaciones);
            this.loading = false;
        }
      });
    } else {
      let dataJason = {
        idcartera: 0,
        idModelo: 0,
        idcarteras: arrayString,
      }
      this.apisseservice.apiPostNew('listaroperaciones', dataJason, licencia).subscribe({
        next: (data: any)=>{
            this.diversificadorsv.updateDivOpe(data);
            this.loading = false;
        }
      });
    }
  }


  onTabChange(event: MatTabChangeEvent): void {
    this.selectedTab = event.index;
    // Igual que en ModelsComponent: la pestaña "Gráfica Análisis" puede haber recibido datos
    // mientras estaba inactiva (contenedor "detached" del DOM) — forzar resize al activarla.
    this.graficaAnalisis?.scheduleEnsureCorrectSize();
  }

  startResizing(event: MouseEvent, column: HTMLElement) {
    // Iniciar redimensionado sólo desde el handle (llamado por el (mousedown) del .resizer)
    if (column && column.tagName === 'DIV') {
      const dataKey = column.getAttribute('data-key') || '';
      const minWidth = 200; // px
      const maxWidth = Math.floor(window.innerWidth * 0.7); // no más del 70% de la pantalla
      const initialX = event.clientX;
      const initialWidth = column.offsetWidth;

      const mouseMoveListener = (mouseEvent: MouseEvent) => {
        let width = initialWidth + (mouseEvent.clientX - initialX);
        if (width < minWidth) width = minWidth;
        if (width > maxWidth) width = maxWidth;
        column.style.width = width + 'px';
      };

      const mouseUpListener = () => {
        document.removeEventListener('mousemove', mouseMoveListener);
        document.removeEventListener('mouseup', mouseUpListener);
        // persistir ancho
        try {
          const w = column.offsetWidth;
          if (dataKey) localStorage.setItem(dataKey, String(w));
        } catch (e) {
          // ignore
        }
      };

      document.addEventListener('mousemove', mouseMoveListener);
      document.addEventListener('mouseup', mouseUpListener);
    }
  }

  // Restaurar anchos guardados (si existen)
  private restoreSavedWidths(): void {
    try {
      const keys = ['diversificador_col_lista', 'diversificador_col_cartera'];
      keys.forEach(key => {
        const v = localStorage.getItem(key);
        if (v) {
          const el = document.querySelector(`[data-key="${key}"]`) as HTMLElement;
          if (el) el.style.width = v + 'px';
        }
      });
    } catch (e) {
      // ignore
    }
  }

  async inicializarDataDiversificador(): Promise<void> {
    await this.diversificadorsv.updateDivOpe([]);
    await this.diversificadorsv.updateDivLate([]);
    await this.diversificadorsv.updateDivLiq([]);
    await this.diversificadorsv.updateDivPos([]);
    await this.diversificadorsv.updateDivVentas([]);
    await this.diversificadorsv.updateDivRent([]);
    await this.diversificadorsv.updateDivRiesgo([]);
    await this.diversificadorsv.updateDivRendAnual([]);
    //this.isAnalisis = true;
    this.diversificadorsv.updatedisAnalisis(false);
    this.divOptimalWallet = JSON.parse(JSON.stringify(this.defaultOptima));
    console.log("Se inicializo divOptimalWallet ", this.divOptimalWallet);
  }

  calcularData(){
    console.log("entro a calcular");
    this.divOptimalWallet.efectivo = this.divOptimalWallet.capitalinicial;
    this.divOptimalWallet.valorLiquidativo = this.divOptimalWallet.capitalinicial; 
    this.divOptimalWallet.fondosDisponibles = this.divOptimalWallet.capitalinicial; 
    this.divOptimalWallet.poderCompra = this.divOptimalWallet.capitalinicial ;
    this.divOptimalWallet.margen=0;
  }
calcularDataApalancamiento() {
            this.divOptimalWallet.capitalinicial = 100000 * this.divOptimalWallet.apalancamiento;
            this.calcularData();
    }
  participacion(event: any, campo: any) {
    if (campo == 'participacion') {
      this.divOptimalWallet.participacion = event.checked;
      console.log("valor de optimalWallet.participacion ", this.divOptimalWallet.participacion);
    }
  }
  guardarPonderador(): void {
    const dialogClass = this.isDark ? 'dark-theme' : 'light-theme';
    const dialogRef = this.dialog.open(DialogNameComponent, {
      width: '300px',
      panelClass: dialogClass,
      data: { name: nombreCarteraConSufijo(this.nombreSugerido, '_DIV'), maxLength: MAX_NOMBRE_CARTERA, mensaje: 'Esta cartera estará disponible en Servicios -> Automatización Carteras' }
    });
console.log("Nombre sugerido ", this.nombreSugerido);
    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result) {
        this.divOptimalWallet.nombre = result;
        let auth_token = this.cookieService.get('auth_token');
        this.divOptimalWallet.capitales = [0,0];
        const idCarteraOptima = this._router.snapshot.queryParams['idcarteraoptima'];
          this.divOptimalWallet.idcarteraoptima = idCarteraOptima ? +String(idCarteraOptima).split(',')[0] : 0;
        this.apisseservice.apiPostNew('registrarcarteraponderador', this.divOptimalWallet, auth_token).subscribe(response => {
          console.log('Response al guardar diversificador:', response);
          if(response.idcartera > 0){
            this.toastr.success("La Cartera esta lista en el Modulo Suscripción Carteras");                    
        }else{
            this.toastr.error(response.error);
        }
        });
      }
    });

  }
  guardarNotificacion(notificacion: Notificacion) {
    notificacion.estado = true;
    console.log(notificacion);


    this.notificacionService.guardarNotificacion(notificacion).subscribe({
      next: (value) => {
        //this.cd.markForCheck();
      },
      error: (err) => {
        console.log("Ocurrió un error actualizando la notificación");
      },
    });
  }
  onTab2Change(event: MatTabChangeEvent): void {
    console.log("Selected tab: ", event.index);
    this.selectedTab2 = event.index;
  }

  showCarteraHelp(): void {
    const helpData: HelpDialogData = {
      title: 'Ayuda - Cartera Óptima',
      items: [
        { term: 'Capital Inicial', description: 'El capital con el que se inicia la cartera.' },
        { term: 'Valor Liquidativo Neto', description: 'Valor actual de todos los activos de la cartera.' },
        { term: 'Efectivo', description: 'Dinero disponible para nuevas operaciones.' },
        { term: 'Tipo Cuenta', description: 'MARGEN (permite apalancamiento) o NOMINAL (sin apalancamiento).' },
        { term: 'Margen Requerido %', description: 'Porcentaje del capital requerido como garantía.' },
        { term: 'Control Margin Call %', description: 'Umbral de alerta para llamada de margen.' },
        { term: 'Riesgo Máximo %', description: 'Porcentaje máximo de capital que se puede arriesgar.' },
        { term: 'Tipo Riesgo', description: 'LIMITADO (según riesgo) o FIJO (cantidad fija).' },
        { term: 'Valor Riesgo', description: 'Valor monetario del riesgo por operación.' }
      ]
    };
    this.dialog.open(HelpDialogComponent, {
      width: '450px',
      data: helpData
    });
  }

  showRiesgoHelp(): void {
    const helpData: HelpDialogData = {
      title: 'Ayuda - Configuración Riesgo',
      items: [
        { term: 'Riesgo Máximo %', description: 'Porcentaje máximo del capital que se puede arriesgar en todas las operaciones abiertas.' },
        { term: 'Tipo Riesgo', description: 'LIMITADO: el tamaño de posición se calcula según el riesgo. FIJO: cantidad fija por operación.' },
        { term: 'Valor Riesgo', description: 'Cantidad monetaria máxima a arriesgar por cada operación individual.' },
        { term: 'Comisión 2/2', description: 'Comisión del broker aplicada tanto a la entrada como a la salida de cada operación.' },
        { term: 'Gastos Gestión', description: 'Porcentaje de gastos de gestión aplicados sobre el capital.' },
        { term: 'Gastos Préstamo %', description: 'Intereses por préstamo de acciones en operaciones en corto (bajistas).' },
        { term: 'Comprar/Vender Fracciones', description: 'Permite comprar fracciones de acciones en lugar de unidades completas.' }
      ]
    };
    this.dialog.open(HelpDialogComponent, {
      width: '450px',
      data: helpData
    });
  }

  showTabHelp(tab: string, event: Event): void {
    event.stopPropagation();
    const tabHelpData: { [key: string]: HelpDialogData } = {
      'gestion': {
        title: 'Ayuda - Gestión/Contabilidad',
        items: [
          { term: 'Resumen', description: 'Vista general del estado de la cartera con métricas principales.' },
          { term: 'Balance', description: 'Registro de movimientos de capital, depósitos y retiros.' },
          { term: 'Comisiones', description: 'Detalle de comisiones pagadas al broker por operaciones.' }
        ]
      },
      'operaciones': {
        title: 'Ayuda - Operaciones',
        items: [
          { term: 'Operaciones Abiertas', description: 'Posiciones actualmente en cartera con su rendimiento en tiempo real.' },
          { term: 'Histórico', description: 'Registro de todas las operaciones cerradas con sus resultados.' },
          { term: 'Filtros', description: 'Permite filtrar operaciones por fecha, tipo, activo, etc.' }
        ]
      },
      'valores': {
        title: 'Ayuda - Valores Liquidativos',
        items: [
          { term: 'VL Diario', description: 'Valor liquidativo neto de la cartera calculado al cierre de cada día.' },
          { term: 'Evolución', description: 'Gráfica de la evolución del valor de la cartera en el tiempo.' },
          { term: 'Drawdown', description: 'Máxima caída desde el punto más alto de la curva de capital.' }
        ]
      },
      'rendimientos': {
        title: 'Ayuda - Rendimientos/Riesgos',
        items: [
          { term: 'Rentabilidad', description: 'Porcentaje de ganancia o pérdida sobre el capital inicial.' },
          { term: 'Sharpe Ratio', description: 'Mide el rendimiento ajustado al riesgo de la cartera.' },
          { term: 'Volatilidad', description: 'Desviación estándar de los rendimientos, indica el riesgo.' },
          { term: 'Max Drawdown', description: 'Máxima pérdida porcentual desde un máximo histórico.' }
        ]
      },
      'cartera': {
        title: 'Ayuda - Cartera',
        items: [
          { term: 'Posiciones', description: 'Lista de activos en cartera con cantidad, precio y valor actual.' },
          { term: 'Ponderación', description: 'Porcentaje que representa cada activo del total de la cartera.' },
          { term: 'P&L', description: 'Ganancia o pérdida (Profit & Loss) de cada posición.' }
        ]
      },
      'modelos': {
        title: 'Ayuda - Modelos',
        items: [
          { term: 'Selección de Modelos', description: 'Lista de modelos disponibles para el diversificador.' },
          { term: 'Comparación', description: 'Permite comparar diferentes modelos para seleccionar los mejores.' },
          { term: 'Asignación', description: 'Define la asignación de capital entre los modelos seleccionados.' }
        ]
      },
      'buscador': {
        title: 'Ayuda - Buscador',
        items: [
          { term: 'Búsqueda', description: 'Encuentra modelos o activos específicos en el diversificador.' },
          { term: 'Filtros Avanzados', description: 'Aplica criterios para refinar los resultados de búsqueda.' },
          { term: 'Resultados', description: 'Muestra los elementos que coinciden con los criterios de búsqueda.' }
        ]
      },
      'graficaAnalisis': {
        title: 'Ayuda - Gráfica Análisis',
        items: [
          { term: 'Gráfica Análisis', description: 'Muestra la gráfica de velas del modelo seleccionado en Gestión/Contabilidad.' },
          { term: 'Selección de activo', description: 'Se actualiza automáticamente al seleccionar una fila con modelo en la tabla de Gestión/Contabilidad.' }
        ]
      }
    };
    const helpData = tabHelpData[tab];
    if (helpData) {
      this.dialog.open(HelpDialogComponent, {
        width: '450px',
        data: helpData
      });
    }
  }
}
